import Api from '@/services/Index';

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/sessions', config);
}
const show = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/session/' + id);
}
const store = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/session', data);
}
const update = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/student/session/' + id, formData);
}
const del = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/student/session/' + id);
}

const getStudentReport = async (id,config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/documents/esl/session-report/' + id, {...config,responseType : 'arraybuffer'});
}

const getRegistration = async (student_program_id) => {
    return Api.get('/student/sessions/registration/' + student_program_id);
}

const registerToSession = async (student_program_id, session_id) => {
    return Api.post('/student/sessions/register/' + student_program_id + '/' + session_id);
}

const finalize = async (student_program_id, session_id) => {
    return Api.post('/student/sessions/finalize/' + student_program_id + '/' + session_id);
}

const createPaymentPlan = async (form) => {
    return Api.post('/student/sessions/payment-plan', form);
}

const sessionAndTimeOffs = async (student_program_id,config) => {
    return Api.get(`/student/programs/${student_program_id}/sessions-and-time-offs`,config);
}



export default {
    getAll,
    show,
    store,
    update,
    del,
    getStudentReport,
    getRegistration,
    registerToSession,
    sessionAndTimeOffs,
    createPaymentPlan,
    finalize
}
